// OneDrive:IgnoreCodeCoverage

import { APICallPerformanceData } from './RUMOneLogger';

export default APICallPerformanceData;